import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getConsultationRooms({ pharmacyId }) {
    const response = await axiosPrivate.get(`/pharmacies/${pharmacyId}/consultation-room`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async addConsultationRoom({ pharmacyId, payload }) {
    const response = await axiosPrivate.post(
      `/pharmacies/${pharmacyId}/consultation-room`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async updateConsultationRoom({ pharmacyId, consultationRoomId, payload }) {
    const response = await axiosPrivate.put(
      `/pharmacies/${pharmacyId}/consultation-room/${consultationRoomId}`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async deleteConsultationRoom({ pharmacyId, consultationRoomId }) {
    const response = await axiosPrivate.delete(
      `/pharmacies/${pharmacyId}/consultation-room/${consultationRoomId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
